import { isArray } from 'lodash';

class OptOutModel {
  static initialValues(values) {
    return {
      id: values?.id,
      title: values?.title || '',
      url: values?.url || '',
      mode: !!values?.url
        ? OptOutModel.modeOptoutLink.customer
        : OptOutModel.modeOptoutLink.textback,
      domain: isArray(values?.domains)
        ? values?.domains?.map((el, i) => ({ label: el, value: values?.domain?.split(',')?.[i] }))
        : [],
      setConfirmed: values?.setConfirmed || false,
    };
  }

  static parseBodyRequest(values) {
    const { mode } = values;

    const url = mode === OptOutModel.modeOptoutLink.textback ? '' : values?.url;
    const needConfirm = mode === OptOutModel.modeOptoutLink.textback ? values?.setConfirmed : false;

    return {
      id: values?.id,
      title: values?.title || '',
      url: url || '',
      domain: isArray(values?.domain) ? values?.domain?.map((el) => el.value).join(',') : '',
      setConfirmed: needConfirm || false,
    };
  }

  //* Optout Link
  static typeOptoutLink = {
    optoutLink: 'optoutLink',
    noOptoutLink: 'no-optoutLink',
  };

  static modeOptoutLink = {
    textback: 'textback',
    customer: 'customer',
  };

  static isNoOptoutLink(optoutLinkType) {
    return optoutLinkType === OptOutModel.typeOptoutLink.noOptoutLink;
  }

  static initialValuesOptoutLink(values) {
    return {
      optoutLinkType: values?.optoutLinkType || OptOutModel.typeOptoutLink.optoutLink,
      optoutLink: values?.optoutLink || [],
    };
  }
}

export default OptOutModel;
